//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// custom pages
import config from "config/index";
import HandleApiResponse from "helpers/handleApiResponse";

const dashboard = () => {
  const { handleResponse, handleError } = HandleApiResponse();

  async function getTier(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-tier/${values}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPoints(loyaltyId) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-points?loyaltyId=${loyaltyId}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  

  async function getIssued(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-issued?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getIssuedFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-issued-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function Export(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/export?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPendingIssued(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-pending-issued?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPendingIssuedFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-pending-issued-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRedeemed(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-redeemed?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getRedeemedFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-redeemed-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPendingRedeemed(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-pending-redeemed?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getPendingRedeemedFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-pending-redeemed-filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function search(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/search?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getTransaction(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-transactions?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function doFilter(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let query;
      query = JSON.stringify(values);
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/filter?query=${query}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getCustomerAccounts(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-customeraccounts?loyaltyId=${values}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getBillingAccount(values) {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(
        `${config.host}/cdr-panel/dashboard/get-billingaccount?loyaltyId=${values}`,
        obj
      );
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  async function getOrg() {
    try {
      const obj = {
        method: "GET",
        credentials: 'include',
        headers: {
          "Content-Type": "application/json"          
        },
      };
      let res = await fetch(`${config.host}/cdr-panel/dashboard/get-org`, obj);
      return handleResponse(res);
    } catch (err) {
      handleError(err);
    }
  }

  return {
    getTier,
    getPoints,
    getIssued,
    getIssuedFilter,
    Export,
    getPendingIssued,
    getPendingIssuedFilter,
    getRedeemed,
    getRedeemedFilter,
    getPendingRedeemed,
    getPendingRedeemedFilter,
    search,
    getTransaction,
    doFilter,
    getCustomerAccounts,
    getBillingAccount,
    getOrg,
   
  };
};

export default dashboard;
